/**
 * <sale-countdown data-ends="ISO-8601 with offset">
 * Swaps the static text for a live countdown. At the end time it hides itself and removes the
 * `sale-live` class (snippets/sale-window), so an open page stops showing the sale too.
 * Fills any [data-unit="d|h|m|s"] children it contains.
 */
class SaleCountdown extends HTMLElement {
  connectedCallback() {
    this.endsAt = Date.parse(this.dataset.ends ?? '');
    if (Number.isNaN(this.endsAt)) return;

    this.liveEl = this.querySelector('[data-countdown-live]');
    this.staticEl = this.querySelector('[data-countdown-static]');
    this.unitEls = [...this.querySelectorAll('[data-unit]')];
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const secondsLeft = Math.floor((this.endsAt - Date.now()) / 1000);
    if (secondsLeft <= 0) {
      clearInterval(this.timer);
      this.hidden = true;
      document.documentElement.classList.remove('sale-live');
      return;
    }

    /** @type {Record<string, number>} */
    const parts = {
      d: Math.floor(secondsLeft / 86400),
      h: Math.floor((secondsLeft % 86400) / 3600),
      m: Math.floor((secondsLeft % 3600) / 60),
      s: secondsLeft % 60,
    };
    for (const el of this.unitEls) {
      el.textContent = String(parts[el.dataset.unit] ?? 0).padStart(2, '0');
    }
    if (this.liveEl && this.liveEl.hidden) {
      this.liveEl.hidden = false;
      if (this.staticEl) this.staticEl.hidden = true;
    }
  }
}

if (!customElements.get('sale-countdown')) customElements.define('sale-countdown', SaleCountdown);
